/**
 * AdminTeam — Gerenciar equipe do tenant (v1: lista admins)
 * White Label Fase 6
 */

import { useState, useEffect } from 'preact/hooks';
import { api } from '../api/client';
import { T } from '../styles/tokens';

interface Member {
  id: string;
  email: string;
  name: string | null;
  role: string;
  created_at: string;
}

export function AdminTeam() {
  const [members, setMembers] = useState<Member[]>([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get<any>('/tenant/team').then((res: any) => {
      setMembers(res?.members || []);
    }).catch((e: any) => setErr(e?.message || 'Erro ao carregar equipe'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '24px 16px' }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: T.text, marginBottom: 4 }}>👥 Equipe</h1>
      <p style={{ color: T.textMuted, fontSize: 14, marginBottom: 24 }}>
        Membros com acesso administrativo ao seu tenant
      </p>

      {err && <div style={{ padding: '10px 14px', background: '#3a1a1a', color: '#f87171', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>{err}</div>}

      {loading ? (
        <div style={{ color: T.textMuted, padding: 20 }}>Carregando...</div>
      ) : members.length === 0 ? (
        <div style={{ color: T.textMuted, padding: 20, textAlign: 'center' }}>
          Nenhum membro encontrado
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: `1px solid ${T.border}` }}>
              <th style={thStyle}>Nome</th>
              <th style={thStyle}>Email</th>
              <th style={thStyle}>Papel</th>
              <th style={thStyle}>Desde</th>
            </tr>
          </thead>
          <tbody>
            {members.map(m => (
              <tr key={m.id} style={{ borderBottom: `1px solid ${T.border}22` }}>
                <td style={tdStyle}>{m.name || '—'}</td>
                <td style={tdStyle}>{m.email}</td>
                <td style={tdStyle}>
                  <span style={{
                    padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600,
                    background: m.role === 'ADMIN' ? '#6C63FF22' : '#FF658422',
                    color: m.role === 'ADMIN' ? '#6C63FF' : '#FF6584',
                  }}>
                    {m.role}
                  </span>
                </td>
                <td style={tdStyle}>{new Date(m.created_at).toLocaleDateString('pt-BR')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div style={{ marginTop: 24, padding: 16, background: T.cardBg || '#1a1a2e', borderRadius: 8, border: `1px solid ${T.border}` }}>
        <div style={{ fontSize: 13, color: T.textMuted }}>
          💡 <strong>Em breve:</strong> Convidar membros, definir papéis e permissões granulares.
        </div>
      </div>
    </div>
  );
}

const thStyle: any = { textAlign: 'left', padding: '10px 12px', fontSize: 12, fontWeight: 600, color: T.textMuted };
const tdStyle: any = { padding: '10px 12px', fontSize: 14, color: T.text };
